module.exports = __webpack_public_path__ + "img/nota-folio-papelia.f920d9c4.png";